module.exports = __webpack_public_path__ + "img/footer_logo.132566b7.png";